// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Public QR menu pages live at /m/:token and need no authentication.
// We branch here — before any hook-using component mounts — so App's hooks
// are never called conditionally (which would violate rules of hooks).
if (window.location.pathname.startsWith('/m/') || window.location.pathname.startsWith('/menu/')) {
  const _p = window.location.pathname;
  const token = (_p.startsWith('/menu/') ? _p.replace(/^\/menu\//, '') : _p.replace(/^\/m\//, '')).split('/')[0];
  const { MemoryRouter, Routes, Route } = require('react-router-dom');
  const PublicMenu = require('./pages/menu/PublicMenu').default;
  root.render(
    <React.StrictMode>
      <MemoryRouter initialEntries={[`/m/${token}`]}>
        <Routes>
          <Route path='/m/:token' element={<PublicMenu />} />
        </Routes>
      </MemoryRouter>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// PWA Service Worker Registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.log('❌ Service Worker registration failed:', error);
      });
  });
}

// PWA Install Prompt
let deferredPrompt;
let installButton = null;

window.addEventListener('beforeinstallprompt', (e) => {
  console.log('💡 PWA install prompt triggered');
  e.preventDefault();
  deferredPrompt = e;
  
  // Create install button if it doesn't exist
  if (!installButton) {
    installButton = document.createElement('button');
    installButton.textContent = '📱 Install Promedia Sign';
    installButton.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 1000;
      background: #007bff;
      color: white;
      border: none;
      padding: 12px 16px;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      box-shadow: 0 4px 12px rgba(0,123,255,0.3);
    `;
    
    installButton.addEventListener('click', async () => {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to install prompt: ${outcome}`);
        deferredPrompt = null;
        installButton.remove();
      }
    });
    
    document.body.appendChild(installButton);
  }
});

// Hide install button when app is installed
window.addEventListener('appinstalled', () => {
  console.log('🎉 PWA was installed');
  if (installButton) {
    installButton.remove();
  }
});